import { createAction } from "redux-actions";

export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const changeLanguage = createAction(CHANGE_LANGUAGE);

export const LOGIN_ACTION = "LOGIN_ACTION";
export const LoginAction = createAction(LOGIN_ACTION);

export const LOGIN_TWO_FACTOR_ACTION = "LOGIN_TWO_FACTOR_ACTION";
export const LoginTwoFactorAction = createAction(LOGIN_TWO_FACTOR_ACTION);

export const LOGIN_SHARE = "LOGIN_SHARE";
export const LoginByTokenAction = createAction(LOGIN_SHARE);

export const LOAD_USER = "LOAD_USER";
export const LoadUser = createAction(LOAD_USER);

export const SET_AUTHENTICATION_TOKEN = "SET_AUTHENTICATION_TOKEN";
export const setAuthenticationToken = createAction(SET_AUTHENTICATION_TOKEN);

export const LOGOUT_ACTION = "LOGOUT_ACTION";
export const LogOutAction = createAction(LOGOUT_ACTION);

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const logoutSuccess = createAction(LOGOUT_SUCCESS);

export const SETTENANT = "SETTENANT";
export const setTenant = createAction(SETTENANT);

export const SAVEFILTER = "SAVEFILTER";
export const saveFilter = createAction(SAVEFILTER);

export const GETUSER_SUCCESS = "GETUSER_SUCCESS";
export const getUserSuccess = createAction(GETUSER_SUCCESS);

export const SETSESSIONPAGE = "SETSESSIONPAGE";
export const setSessionPage = createAction(SETSESSIONPAGE);

export const SETSESSIONFILTER = "SETSESSIONFILTER";
export const setSessionFilter = createAction(SETSESSIONFILTER);

export const GETFILTERS_SUCCESS = "GETFILTERS_SUCCESS";
export const getFiltersSuccess = createAction(GETFILTERS_SUCCESS);

export const DELETE_FILTERS = "DELETE_FILTERS";
export const deleteFilters = createAction(DELETE_FILTERS);

export const SET_SESSION_DOWNLOADS = "SET_SESSION_DOWNLOADS";
export const SetSessionDownloads = createAction(SET_SESSION_DOWNLOADS);

export const GET_SESSION_DOWNLOADS = "GET_SESSION_DOWNLOADS";
export const GetSessionDownloads = createAction(GET_SESSION_DOWNLOADS);

// GetToken
export const GET_TOKEN = "GET_TOKEN";
export const GetToken = createAction(GET_TOKEN);

// GetTokenForMeddream
export const GET_TOKEN_FOR_MEDDREAM = "GET_TOKEN_FOR_MEDDREAM";
export const GetTokenForMeddream = createAction(GET_TOKEN_FOR_MEDDREAM);

// updateJwtToken
export const UPDATE_JWT_TOKEN = "UPDATE_JWT_TOKEN";
export const updateJwtToken = createAction(UPDATE_JWT_TOKEN);

// requestLoginAgain
export const REQUEST_LOGIN_AGAIN = "REQUEST_LOGIN_AGAIN";
export const requestLoginAgain = createAction(REQUEST_LOGIN_AGAIN);
// cancelRequestLoginAgain
export const CANCEL_REQUEST_LOGIN_AGAIN = "CANCEL_REQUEST_LOGIN_AGAIN";
export const cancelRequestLoginAgain = createAction(CANCEL_REQUEST_LOGIN_AGAIN);
